<h1 mat-dialog-title> Valida Postulación Fallecimiento </h1> <br/>

<mat-dialog-content>
  
    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <p> Beneficiario </p>

            <mat-select *ngIf="data.carga" [(ngModel)]="data.beneficiario" [disabled]="data.deshabilitado" required>

                <mat-option *ngFor="let postulante of data.postulantes" value="{{postulante.id}}">

                    {{postulante.rut}} - {{postulante.dv}} {{postulante.nombres}} {{postulante.apellidoPaterno}}

                </mat-option>

            </mat-select>

            <input *ngIf="!data.carga" matInput [disabled]="true" [value]="data.beneficiario" />

        </mat-form-field>
    </p>
  
    <div class="table-responsive" *ngIf="data.mostrarTitularCarga == true">

        <table class="table">

            <thead style="background-color: #0f69b4;color:white;">

                <tr>
                    <th scope="col"> Rut </th>

                    <th scope="col"> Nombre y Apellidoss </th>

                    <th scope="col"> Parentesco </th>

                    <th scope="col"> Edad </th>

                    <th scope="col"> Sexo </th>

                    <th scope="col"> Seleccionar </th>
                </tr>

            </thead>

            <tbody  *ngIf="data.mostrarTitularCarga == true">

                <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let postulante of data.postulantes; let i = index">

                    <td> {{postulante.rut + '-' + postulante.dv}} </td>

                    <td> {{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                    <td> {{postulante.parentesco}} </td>

                    <td> {{postulante.fechaNacimiento}} </td>

                    <td> {{postulante.sexo.nombre}} </td>

                    <td>
                                  
                        <input type="radio"  [checked]="(postulante.id==data.idCarga)"  [disabled]="true" name="postulante"  (click)="esconderBeneficiarios(postulante.parentesco)" >

                    </td>

                </tr>

            </tbody>

        </table>

    </div>

    <br/>

    <div class="row">
        <div class="col-lg-2"> </div>
        <div class="col-lg-4">
            <input type="checkbox"  id="scales" name="scales"  #scales="ngModel"
            [(ngModel)]="data.scales" (click)="muestraRecienNacido($event)" 
            [disabled]="data.deshabilitado" >
            <label for="scales"> Fallecimiento Recién nacido/Mortinato</label>
        </div>
        <div class="col-lg-8"></div>
    </div>
  
    <div class="row" *ngIf="data.nacido == true">
        <div class="col-lg-2"> </div>
        <div class="col-lg-8" style="border: 1px dotted  black">
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <label> Rut Hija/o </label>
                </div>

                <div class="col-lg-5">

                    <input id="rutHijo" name="rutHijo" [(ngModel)]="data.rutHijo" #rutHijo="ngModel" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" [disabled]="data.deshabilitado"/>

                </div>
                <div class="col-lg-3">
                    <button class="btn btn-info" (click)="buscarHijo(data.rutHijo)">
                        Consultar
                    </button>
                 </div>
            </div>
            <br/>
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <label>Nombre Completo </label>
                </div>

                <div class="col-lg-5">

                    <input id="nombreHijo" name="nombreHijo"  [(ngModel)]="data.nombreHijo" #nombreHijo="ngModel" class="form-control" type="text" required required placeholder="Nombre del hijo" [disabled]="data.deshabilitado"/>

                </div>

                <div class="col-lg-1"> </div>
            </div>
        </div>
        <div class="col-lg-2"> </div>
    </div>
    <br/>
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-8">
            <h2> Datos Fallecimiento </h2>
        </div>

        <div class="col-lg-3"> </div>

    </div>
    <br/>

    <div class="row line">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Fecha defunción </p>
        </div>

        <div class="col-lg-5">

            <input class="form-control"  id="fechaFallecimiento" name="fechaFallecimiento" #fechaFallecimiento="ngModel"
            [(ngModel)]="data.fechaFallecimiento" required type="date" [disabled]="data.deshabilitado">

        </div>

        <div class="col-lg-3"> </div>

    </div>

    <br />

  

    <p>
        <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPostulacion)">

        <i class = "fa fa-download"> </i> Descargar Archivos Ingresado </button>
    </p>

   
    <div class="row" *ngIf="data.mostrarBeneficiarios == true">
        <div class="col-lg-2" *ngIf="data.mostrarBeneficiarios == true">
             <h2> Beneficiarios: </h2>
         </div>
        <div class="col-lg-9" *ngIf="data.mostrarBeneficiarios == true">
           </div>
        </div>
         <!--
         <div class="table-responsive"   *ngIf="data.mostrarBeneficiarios == true">
             <form #beneficiarioForm=ngForm>
                 <div class="col-lg-1"> </div>
                 <div class="col-lg-9" style="border: 1px dotted  black">
                     <div class="row">
 
                         <div class="col-lg-1"> </div>
 
                         <div class="col-lg-3">
                             <label> Rut Beneficiario </label>
                         </div>
 
                         <div class="col-lg-6">
 
                             <input id="rutBeneficiario" name="rutBeneficiario" #rutBeneficiario="ngModel" 
                             [(ngModel)]="data.beneficiarios.rutBeneficiario" class="form-control" type="text" required placeholder="Ingrese el RUT del beneficiado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" [disabled]="data.deshabilitado"/>
 
                         </div>
 
                         <div class="col-lg-3"> </div>
                     </div>
                     <br/>
                     <div class="row">
 
                         <div class="col-lg-1"> </div>
 
                         <div class="col-lg-3">
                             <label>Nombre y Apellido  </label>
                         </div>
 
                         <div class="col-lg-6">
 
                             <input id="nombreApellidoBeneficiario" name="nombreApellidoBeneficiario" #nombreApellidoBeneficiario="ngModel" [(ngModel)]="data.beneficiarios.nombreApellidoBeneficiario" class="form-control" type="text" required placeholder="Ingrese el nombre y apellido del afiliado" [disabled]="data.deshabilitado"/>
 
                         </div>
 
                         <div class="col-lg-1"> </div>
                     </div>
                     <br/>
                     <div class="row">
 
                         <div class="col-lg-1"> </div>
 
                         <div class="col-lg-3">
                             <label>Parentesco</label>
                         </div>
 
                        <div class="col-lg-6">
                             <mat-select class="form-control" name="tipoParentesco" #tipoParentesco="ngModel" 
                                 [(ngModel)]="data.beneficiarios.tipoParentesco" required>
         
                                 <mat-option value="0">
                                     SELECCIONE....
                                 </mat-option>
                                 <mat-option *ngFor="let tipo of this.data.tipos" value="{{tipo.id}}">
                                     {{tipo.descripcion}}
                                 </mat-option>
                             </mat-select>
                         </div>
 
                         <div class="col-lg-1"> </div>
                     </div>
                     <br/>
                     <div class="row">
 
                         <div class="col-lg-1"> </div>
 
                         <div class="col-lg-3">
                             <label>% Capital</label>
                         </div>
 
                         <div class="col-lg-4">
 
                             <input id="capitalBeneficiario" name="capitalBeneficiario" #capitalBeneficiario="ngModel" [(ngModel)]="data.beneficiarios.capitalBeneficiario" class="form-control" type="text" required placeholder="Ingrese porcentaje (1-100)" (keypress)="validateFormat($event)" />
 
                         </div>
                      
                         <div class="col-lg-9"> </div>    
                         <div class="col-lg-3" style = "text-align:right;"> <button  class="btn btn-info" (click)="agregarBeneficiario(beneficiarioForm)"> + </button> </div>       
                     </div>
                 </div>           
                 <div class="col-lg-2"> </div>
             </form>
         </div>         
         <br/>
        -->     
     
         <!--      <div class="table-responsive"  *ngIf="data.mostrarBeneficiarios == true">  -->
         <div class="table-responsive" >          
                 <table class="table">
                     <thead style="background-color: #0f69b4;color:white;">
                         <tr>
                             <th scope="col"> Rut Beneficiario</th>
                             <th scope="col"> Nombre y Apellido </th>
                             <th scope="col"> Parentesco </th>
                             <th scope="col"> % Capital </th>
                         </tr>
                     </thead>
               
                     <tbody>                     
                         <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let plan of data.beneficiarios | paginate: data.config; let i = index">
                         
                            <td style="text-align: left;">{{plan.rutBeneficiario}}</td>
                             <td style="text-align: left;">{{plan.nombreApellidoBeneficiario}}</td>
                             <td style="text-align: left;">{{plan.parentescoBeneficiario}}</td>
                              <td style="text-align: left;">{{plan.capitalBeneficiario}}</td>
                         </tr>
                     </tbody>
 
                 </table>           
         </div>
     



</mat-dialog-content> <br/>

<mat-dialog-actions>
    <div *ngIf="data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-warning" (click)="onEditarClick()">
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.mostrarAprobarButton" mat-button class="mat-raised-button btn-success" (click)="onAprobarClick()">
            <i class = "fa fa-check"> </i> Aprobar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class = "fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick()">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>

    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>